@if (model$ | async; as model) {
  <div class="cx-page">
    <section class="cx-page-section">
      <div class="container">
        <div class="row">
          @if (viewMode$ | async; as viewMode) {
            <div class="col-12 col-lg-12">
              <div class="cx-sorting top">
                <div class="row">
                  <div class="col-12 col-lg-4 mr-auto">
                    <div class="form-group cx-sort-dropdown">
                      <cx-sorting
                        [sortOptions]="model.sorts"
                        (sortListEvent)="sortList($event)"
                        [selectedOption]="model.pagination.sort"
                    placeholder="{{
                      'productList.sortByRelevance' | cxTranslate
                    }}"
                      ></cx-sorting>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <button
                      class="btn btn-secondary btn-block mb-3"
                      type="button"
                      (click)="onExport()"
                      >
                      {{ 'deliveryNotes.buttons.export' | cxTranslate }}
                    </button>
                  </div>
                  @if (!isInfiniteScroll) {
                    <div class="col-auto">
                      <div
                        class="cx-pagination"
                        aria-label="product search pagination"
                        >
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                        ></cx-pagination>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="cx-product-container">
                <!-- Product list when using pagination -->
                @if (!isInfiniteScroll) {
                  @for (product of model?.products; track product) {
                    <cx-product-list-item
                      [product]="product"
                      class="cx-product-search-list"
                    ></cx-product-list-item>
                  }
                } @else {
                  <app-uig-product-scroll
                    [scrollConfig]="scrollConfig"
                    [model]="model"
                    [inputViewMode]="viewMode"
                  ></app-uig-product-scroll>
                }
                <!-- Product list when using infinite scroll -->
              </div>
              <div class="cx-sorting bottom">
                <div class="row">
                  <div class="col-12 col-lg-4 mr-auto">
                    <div class="form-group cx-sort-dropdown">
                      <cx-sorting
                        [sortOptions]="model.sorts"
                        (sortListEvent)="sortList($event)"
                        [selectedOption]="model.pagination.sort"
                    placeholder="{{
                      'productList.sortByRelevance' | cxTranslate
                    }}"
                      ></cx-sorting>
                    </div>
                  </div>
                  @if (!isInfiniteScroll) {
                    <div
                      class="col-auto"
                      aria-label="product search pagination"
                      >
                      <div class="cx-pagination">
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                        ></cx-pagination>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  </div>
}
